import { gql } from 'apollo-angular';

export const CreateDirectUploadMutation = gql`
  mutation createDirectUpload($input: CreateDirectUploadInput!) {
    createDirectUpload(input: $input) {
      directUpload {
        signedId
        uploadHeaders
        uploadUrl
      }

      errors {
        message
        path
      }
    }
  }
`;

export const DestroyAttachedFileMutation = gql`
  mutation destroyAttachedFile($input: DestroyAttachedFileInput!) {
    destroyAttachedFile(input: $input) {
      attachedFile {
        id
      }

      errors {
        message
        path
      }
    }
  }
`;
